<template>
    <div class="container d-flex justify-content-center text-center">
        <h2 class="text-white mt-5">
            {{ $t('message.pageNotFound') }}
        </h2>
    </div>
</template>

<script>
    export default {
        name: 'NotFound'
    };
</script>
